import { render, staticRenderFns } from "./NumberFormatter.vue?vue&type=template&id=2c5a53b9&"
import script from "./NumberFormatter.vue?vue&type=script&lang=js&"
export * from "./NumberFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports